import { CommitteeList } from "../components/CommitteeList";

export default function Committees() {
    return (
        <div className="container py-3">
            <div className="row justify-content-center">
                <h2 className="text-center">Committees</h2>
                <CommitteeList/>
            </div>
        </div>
    );
}